import { HsbEntity } from '../../hsbcad-model';
import { ICloneData, IModelReferences } from '../../isharedata';
import { Comment } from './Comment';
import IUserInteractable from './IUserInteractable';

export enum States {
    OPEN = 'Open',
    ACTIVE = 'Active',
    IN_PROGRESS = 'InProgress',
    ON_HOLD = 'OnHold',
    RESOLVED = 'Resolved',
    CLOSED = 'Closed',
    DUE = 'Due',
}

export enum Priorities {
    MINOR = 'Minor',
    NORMAL = 'Normal',
    MAJOR = 'Major',
    CRITICAL = 'Critical',
    SHOW_STOPPER = 'ShowStopper',
}

export enum Types {
    BUG = 'Bug',
    WISH = 'Wish',
    QUESTION = 'Question',
    TASK = 'Task',
}

export default class Issue implements ICloneData<Issue>, IUserInteractable {
    /**
     * THe _id of the Issue
     */
    private _id: string;
    /**
     * THe _id of the Issue
     */
    public get id(): string {
        return this._id;
    }
    /**
     *The title of the issue.
     */
    private _title: string;
    /**
     *The title of the issue.
     */
    public get title(): string {
        return this._title;
    }
    /**
     *The title of the issue.
     */
    public set title(v: string) {
        this._title = v;
    }

    /**
     *The desired priority of the issue
     */
    private _priority: Priorities | null = null;
    /**
     *The desired priority of the issue
     */
    public get priority(): Priorities | null {
        return this._priority;
    }
    /**
     *The desired priority of the issue
     */
    public set priority(v: Priorities | null) {
        this._priority = v;
    }

    /**
     *The type of issue
     */
    private _type: Types | null = null;
    /**
     *The type of issue
     */
    public get type(): Types | null {
        return this._type;
    }
    /**
     *The type of issue
     */
    public set type(v: Types | null) {
        this._type = v;
    }

    /**
     *The state of the issue
     */
    private _state: States | null = null;
    /**
     *The state of the issue
     */
    public get state(): States | null {
        return this._state;
    }
    /**
     *The state of the issue
     */
    public set state(v: States | null) {
        this._state = v;
    }

    /**
     * The comments posted for this issue
     */
    private _comments: Comment[] = [];
    /**
     * The comments posted for this issue
     */
    public get comments(): Comment[] {
        return this._comments;
    }

    /**
     * The entities to which this issue is bound
     */
    private _references: IModelReferences = {};
    /**
     * The entities to which this issue is bound
     */
    public get references(): IModelReferences {
        return this._references;
    }
    /**
     * The entities to which this issue is bound
     */
    public set references(v: IModelReferences) {
        this._references = v;
    }

    /**
     * Description of this issue
     */
    private _description: string = '';
    /**
     * Description of this issue
     */
    public get description(): string {
        return this._description;
    }
    /**
     * Description of this issue
     */
    public set description(v: string) {
        this._description = v;
    }

    /**
     * The user this is assigned to
     */
    private _assigned_to: string = '';
    /**
     * The user this is assigned to
     */
    public get assigned_to(): string {
        return this._assigned_to;
    }
    /**
     * The user this is assigned to
     */
    public set assigned_to(v: string) {
        this._assigned_to = v;
    }
    /**
     * The user this is assigned to
     */
    private _creator: string = '';
    /**
     * The user this is assigned to
     */
    public get creator(): string {
        return this._creator;
    }
    /**
     * The user this is assigned to
     */
    public set creator(v: string) {
        this._creator = v;
    }

    constructor(
      id: string,
        title?: string,
        references?: IModelReferences,
        parameters?: Omit<IssueProps, 'title'>
    ) {
      this._id = id;
        this._title = title ?? 'New Issue';
        this._references = references ?? {};
        this._priority = parameters?.priority ?? Priorities.NORMAL;
        this._state = parameters?.state ?? States.OPEN;
        this._type = parameters?.type ?? Types.TASK;
    }

    addComments(comment: Comment) {
        this._comments.push(comment);
    }

    removeComment(index: number) {
        return this._comments.splice(index, 1);
    }

    clone() {
        let clone = new Issue(this.id,this.title, this.references);
        clone.priority = this.priority;
        clone.state = this.state;
        clone.type = this.type;
        return clone as this;
    }
}

export interface IssueProps {
    state?: States | null;
    priority?: Priorities | null;
    type?: Types | null;
    title: string;
    assigned_to: string;
    creator: string;
}
